import { ConvertToCurrentTimeZone } from '../../components/header/timeFormatter';
import { OfflineService } from "../storageService/offlineService";
import { LoadStaffingDetails } from "./staffingOfflineData";
import { LoadJournalDetails, LoadWhoCalledItems } from "./journalOfflineData";
import { LoadLocations, LoadVisitationTypes, LoadVisitationTemplates, LoadVisitationEVSDetails, LoadVisitationAnswers } from "./visitationEVSOfflineData";
import { LoadRecoveryEVSDetails } from "./recoveryEVSOfflineData";
import { LoadCoachDetails } from "./teamCoachOfflineData";
import { LoadRDOAccountVisitations, LoadRDOSectionsForAll, LoadRDOAndDirector, LoadRDOParameters, LoadRDOAccountVisitTemplate } from "./rdoAccountVisitationOfflineData";
import { LoadRoundDetails, LoadRoundList, LoadAssignedToUsers, LoadResolutions, LoadComments } from "./roundOfflineData";
import { LoadHuddles } from "./huddleOfflineData";
import { LoadSafetyCoachingOfflineDetails, LoadSafetyCoachingDetails } from "./safetyCoachingOfflineData";

const LoadOfflineDatas = (defaultSite, modules, loadOnInit, personId) => {
    let date = ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite);
    let assignedToUsersLoaded = false;
    let visitationLoaded = false;
    let supervisorAndEmployeeLoaded = false;

    const isAuthorized = (title) => {
        if (modules !== undefined && modules.length > 0) {
            const index = modules.findIndex(item => item.title === title);
            return (index === -1) ? false : true;
        }
        else
            return false;
    };

    if (loadOnInit) {
        //Load Coach offline data to IndexedDB
        if (isAuthorized('Coach')) {
            if (!supervisorAndEmployeeLoaded) {
                LoadSafetyCoachingOfflineDetails(defaultSite);
                supervisorAndEmployeeLoaded = true;
            }
            LoadCoachDetails(defaultSite, date, personId);
        }

        //Load RDOAccountVisitation offline data to IndexedDB
        if (isAuthorized('RDOAccountVisitation')) {
            LoadRDOAndDirector(defaultSite);
            LoadRDOParameters(defaultSite);
            LoadRDOAccountVisitTemplate(defaultSite, date);
        }

        //Load Round offline data to IndexedDB
        if (isAuthorized('Round')) {
            if (!assignedToUsersLoaded) {
                LoadAssignedToUsers(defaultSite);
                assignedToUsersLoaded = true;
            }
            LoadRoundList(defaultSite, date);
            LoadResolutions();
            LoadComments();
        }

        //Load SafetyCoaching offline data to IndexedDB
        if (isAuthorized('SafetyCoaching')) {
            if (!supervisorAndEmployeeLoaded) {
                LoadSafetyCoachingOfflineDetails(defaultSite);
                supervisorAndEmployeeLoaded = true;
            }
        }

        //Load EVS Visitation offline data to IndexedDB
        if (isAuthorized('VisitationEVS')) {
            if (!assignedToUsersLoaded) {
                LoadAssignedToUsers(defaultSite);
                assignedToUsersLoaded = true;
            }

            if (!visitationLoaded) {
                LoadLocations(defaultSite, date);
                LoadVisitationTypes(defaultSite);
                visitationLoaded = true;
            }

            LoadVisitationTemplates(defaultSite);
        }

        //Load EVS Recovery offline data to IndexedDB
        if (isAuthorized('Recovery')) {
            if (!assignedToUsersLoaded) {
                LoadAssignedToUsers(defaultSite);
                assignedToUsersLoaded = true;
            }

            if (!visitationLoaded) {
                LoadLocations(defaultSite, date);
                LoadVisitationTypes(defaultSite);
                visitationLoaded = true;
            }
        }
    }

    //Load EVS Visitation offline data to IndexedDB
    if (isAuthorized('VisitationEVS')) {
        LoadVisitationEVSDetails(defaultSite, date);
        LoadVisitationAnswers(defaultSite);
    }

    //Load EVS Recovery offline data to IndexedDB
    if (isAuthorized('Recovery')) {
        LoadRecoveryEVSDetails(defaultSite, date);
    }

    //Load Staffing offline data to IndexedDB
    if (isAuthorized('Staffing'))
        LoadStaffingDetails(defaultSite, date);

    //Load Journal offline data to IndexedDB
    if (isAuthorized('Journal')) {
        LoadJournalDetails(defaultSite, date);
        LoadWhoCalledItems(defaultSite);
    }

    //Load RDOAccountVisitation offline data to IndexedDB
    if (isAuthorized('RDOAccountVisitation')) {
        LoadRDOAccountVisitations(defaultSite, date);
        LoadRDOSectionsForAll(defaultSite, date);
    }

    //Load Huddle offline data to IndexedDB
    if (isAuthorized('Huddle'))
        LoadHuddles(defaultSite, date);

    //Load Round offline data to IndexedDB
    if (isAuthorized('Round')) {
        LoadRoundDetails(defaultSite);
    }

    //Load SafetyCoaching offline data to IndexedDB
    if (isAuthorized('SafetyCoaching')) {
        LoadSafetyCoachingDetails(defaultSite, date);
    }
};

const RemoveOfflineDatas = async (siteId) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflineNames(siteId);

    offlineResult.forEach(name => {
        offlineService.removeOfflineBySite(siteId, name);
    });
}

export { LoadOfflineDatas, RemoveOfflineDatas }
